import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uploadFileFilter',
})
export class UploadFileFilter implements PipeTransform {
  transform(file: any, filter_type = 'total_selected_files'): any {
    if (filter_type === 'total_selected_files') {
      return file.filter((item) => item.selected);
    } else if (filter_type === 'save_enable') {
      return file.filter((x) => x.vault_details == null).length > 0 ? false : true;
    } else {
      return file;
    }
  }
}
